module.exports = __webpack_public_path__ + "static/footer-bg-mobile-096f2eab8d3a0d742bf60b6e8d282f39.jpg";